import { render, staticRenderFns } from "./DeclineAction.vue?vue&type=template&id=23ad173f&scoped=true&"
import script from "./DeclineAction.vue?vue&type=script&lang=js&"
export * from "./DeclineAction.vue?vue&type=script&lang=js&"
import style0 from "./DeclineAction.vue?vue&type=style&index=0&id=23ad173f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ad173f",
  null
  
)

export default component.exports